import React, { FC } from 'react';

import { useIsRtlText } from '../../hooks';
import { DirectionWrapper } from '../DirectionWrapper';

interface TextWithAutoDirectionProps {
  text: string;
  dataHook?: string;
}

/**
 * Handy component to render text with detecting direction. Works for simple strings only and doesn't support jsx.
 */
export const TextWithAutoDirection: FC<TextWithAutoDirectionProps> = ({ text, dataHook }) => {
  const isRtl = useIsRtlText(text);

  return (
    <DirectionWrapper isRtl={isRtl}>
      <span {...(dataHook && { 'data-hook': dataHook })}>{text}</span>
    </DirectionWrapper>
  );
};
